import React, { useState } from "react";
import NewDoctorList from "./NewDoctorList";
import NewPriestList from "../../Priest/PriestList";
import Footer from "../../../components/footer/Footer";
import Header from "../../../components/header/Header";
import { Link, useLocation, useParams } from "react-router-dom";
import { Tab, Tabs } from "react-bootstrap";
import queryString from "query-string";
const DoctorPriestList = () => {
  // const param = useParams();
  const location = useLocation();

  const params = queryString.parse(window.location.search);
  console.log(params, "meeting_d21dde08ata");

  return (
    <>
      <Header />
      <section className="doctorsec-pad">
        <div className="container">
          <div className="mt-4">
            <div className="mt-4">
              <p className="font_22 font_600 mb-0">
                {params?.isPriestMeeting == "true" ? "Priests" : "Doctors"}{" "}
              </p>

              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/patient/home" className="font_14">
                      Home
                    </Link>
                  </li>
                  <li
                    className="breadcrumb-item active font_14"
                    aria-current="page"
                  >
                    {params?.isPriestMeeting == "true" ? "Priests" : "Doctors"}
                  </li>
                </ol>
              </nav>
            </div>
            {params?.isPriestMeeting == "true" ? (
              <NewPriestList />
            ) : (
              <NewDoctorList />
            )}

            {/* */}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default DoctorPriestList;
